import {
  Col,
  Row,
  Space,
  Table,
  Card,
  Button,
  message,
  Spin,
  Select,
  Flex,
  Input,
  notification,
  Modal,
  Empty,
  Typography,
  List,
} from "antd";
import React, {
  useCallback,
  useEffect,
  useState,
  useMemo,
  useRef,
} from "react";
import {
  PlusOutlined,
  ReloadOutlined,
  FileTextOutlined,
} from "@ant-design/icons";
import MotionHoc from "../../../utils/MotionHoc";
import { Link } from "react-router-dom";
import axios from "axios";
import dayjs from "dayjs";
import CreateAdvanePayment from "./modal/CreateAdvanePayment";
import {
  HEADERS_EXPORT_BEN,
  POST_CHECK_BILL,
  POST_MAIN_WITHDRAW,
} from "../../API/apiUrls";
import { ThaiRangePicker } from "../../../hook/ThaiDatePicker";
import LoadCompanies from "../../../hook/LoadCompanies";

// ✅ Constants
const MAX_SELECTION = 10;
const DEFAULT_PAGE_SIZE = 10;
const PAGE_SIZE_OPTIONS = ["10", "20", "50", "100"];
const COMPANY_GROUPS = {
  1: [1, 4],
  4: [1, 4],
  2: [2, 5],
  5: [2, 5],
  3: [3],
};

const Main = () => {
  const userCompany = localStorage.getItem("COMPANY_ID");
  const userId = parseInt(localStorage.getItem("USER_ID"));
  const abortControllerRef = useRef(null);
  const { Text } = Typography;
  const { companiesOptions: allCompaniesOptions, loading: loadingCompanies } =
    LoadCompanies();

  // ✅ Default company based on user
  const defaultCompany = useMemo(() => {
    return userCompany === "3" ? 3 : 1;
  }, [userCompany]);

  // States
  const [isModalCreateAdvanePayment, setIsModalCreateAdvanePayment] =
    useState(false);
  const [arrayTable, setArrayTable] = useState([]);
  const [dataArr, setDataArr] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dataModal, setDataModal] = useState([]);
  const [companieSelect, setCompanieSelect] = useState(defaultCompany);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [dateRange, setDateRange] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [checkBillData, setCheckBillData] = useState([]);

  const data = [
    {
      lawsuitId: 40,
      loanId: 40,
      CONTNO: "1-0006601",
      CUSCOD: "3450600372244",
      SNAM: "นาง",
      NAME1: "นนทน์ธีกรณัฐ",
      NAME2: "กิตติซาระบุตร",
      workExpenseList: [
        {
          id: 398,
          TMBILL: null,
          lawsuitId: 40,
          expenseTypeId: 7,
          NETPAY: "5",
          NETPAY_DT: null,
          payTypeId: null,
          PAY: null,
          PAYDT: null,
          FLAG: "N",
          CANDT: null,
          CANDT_USER: null,
        },
        {
          id: 399,
          TMBILL: null,
          lawsuitId: 40,
          expenseTypeId: 8,
          NETPAY: "5",
          NETPAY_DT: null,
          payTypeId: null,
          PAY: null,
          PAYDT: null,
          FLAG: "N",
          CANDT: null,
          CANDT_USER: null,
        },
        {
          id: 400,
          TMBILL: null,
          lawsuitId: 40,
          expenseTypeId: 9,
          NETPAY: "50",
          NETPAY_DT: null,
          payTypeId: null,
          PAY: null,
          PAYDT: null,
          FLAG: "N",
          CANDT: null,
          CANDT_USER: null,
        },
        {
          id: 401,
          TMBILL: null,
          lawsuitId: 40,
          expenseTypeId: 10,
          NETPAY: "100",
          NETPAY_DT: null,
          payTypeId: null,
          PAY: null,
          PAYDT: null,
          FLAG: "N",
          CANDT: null,
          CANDT_USER: null,
        },
        {
          id: 402,
          TMBILL: null,
          lawsuitId: 40,
          expenseTypeId: 11,
          NETPAY: "50",
          NETPAY_DT: null,
          payTypeId: null,
          PAY: null,
          PAYDT: null,
          FLAG: "N",
          CANDT: null,
          CANDT_USER: null,
        },
        {
          id: 403,
          TMBILL: null,
          lawsuitId: 40,
          expenseTypeId: 12,
          NETPAY: "5",
          NETPAY_DT: null,
          payTypeId: null,
          PAY: null,
          PAYDT: null,
          FLAG: "N",
          CANDT: null,
          CANDT_USER: null,
        },
        {
          id: 404,
          TMBILL: null,
          lawsuitId: 40,
          expenseTypeId: 13,
          NETPAY: "5",
          NETPAY_DT: null,
          payTypeId: null,
          PAY: null,
          PAYDT: null,
          FLAG: "N",
          CANDT: null,
          CANDT_USER: null,
        },
        {
          id: 405,
          TMBILL: null,
          lawsuitId: 40,
          expenseTypeId: 14,
          NETPAY: "50",
          NETPAY_DT: null,
          payTypeId: null,
          PAY: null,
          PAYDT: null,
          FLAG: "N",
          CANDT: null,
          CANDT_USER: null,
        },
        {
          id: 406,
          TMBILL: null,
          lawsuitId: 40,
          expenseTypeId: 15,
          NETPAY: "50",
          NETPAY_DT: null,
          payTypeId: null,
          PAY: null,
          PAYDT: null,
          FLAG: "N",
          CANDT: null,
          CANDT_USER: null,
        },
        {
          id: 407,
          TMBILL: null,
          lawsuitId: 40,
          expenseTypeId: 16,
          NETPAY: "100",
          NETPAY_DT: null,
          payTypeId: null,
          PAY: null,
          PAYDT: null,
          FLAG: "N",
          CANDT: null,
          CANDT_USER: null,
        },
        {
          id: 408,
          TMBILL: null,
          lawsuitId: 40,
          expenseTypeId: 23,
          NETPAY: "300",
          NETPAY_DT: null,
          payTypeId: null,
          PAY: null,
          PAYDT: null,
          FLAG: "N",
          CANDT: null,
          CANDT_USER: null,
        },
        {
          id: 409,
          TMBILL: null,
          lawsuitId: 40,
          expenseTypeId: 24,
          NETPAY: "20",
          NETPAY_DT: null,
          payTypeId: null,
          PAY: null,
          PAYDT: null,
          FLAG: "N",
          CANDT: null,
          CANDT_USER: null,
        },
        {
          id: 410,
          TMBILL: null,
          lawsuitId: 40,
          expenseTypeId: 25,
          NETPAY: "1200",
          NETPAY_DT: null,
          payTypeId: null,
          PAY: null,
          PAYDT: null,
          FLAG: "N",
          CANDT: null,
          CANDT_USER: null,
        },
      ],
    },
  ];

  // ✅ โหลดข้อมูลหลัก - ใช้ useRef สำหรับ AbortController
  const loadMain = useCallback(async () => {
    // Cancel previous request
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
    abortControllerRef.current = new AbortController();

    setLoading(true);

    try {
      const res = await axios.post(
        POST_MAIN_WITHDRAW,
        { userId, currentStatus: 4 },
        {
          headers: HEADERS_EXPORT_BEN,
          signal: abortControllerRef.current.signal,
        },
      );

      if (res.data?.length > 0) {
        const filteredData = res.data.filter(
          (item) =>
            item.currentStatus >= 3 &&
            item.currentStatus <= 5 &&
            !item.fee_payment_status,
        );
        setDataArr(filteredData);
        setArrayTable(filteredData);
        // setDataArr(res.data);
        // setArrayTable(res.data);
      } else {
        setDataArr([]);
        setArrayTable([]);
        message.info("ไม่มีข้อมูล");
      }
    } catch (error) {
      if (error.name === "CanceledError") return;

      console.error("❌ Error loading data:", error);
      message.error(error.response?.data?.message || "ไม่สามารถโหลดข้อมูลได้");
      setDataArr([]);
      setArrayTable([]);
    } finally {
      setLoading(false);
    }
  }, [userId]);

  // ✅ Cleanup on unmount
  useEffect(() => {
    // loadMain();

    return () => {
      abortControllerRef.current?.abort();
    };
  }, [loadMain]);

  // ✅ Check bill - เพิ่ม async/await handling
  const loadCheckBill = useCallback(async () => {
    setLoading(true);
    const payload = { companyId: companieSelect, userId };
    try {
      const response = await axios.post(POST_CHECK_BILL, payload, {
        headers: HEADERS_EXPORT_BEN,
      });

      if (response.data && Array.isArray(response.data)) {
        return response.data;
      }

      message.warning("ไม่พบข้อมูล");
      return null;
    } catch (error) {
      console.error("Error loading data:", error);
      message.error(`เกิดข้อผิดพลาด: ${error.message}`);
      return null;
    } finally {
      setLoading(false);
    }
  }, [companieSelect, userId]);

  // ✅ Companies Options
  const companiesOptions = useMemo(() => {
    if (!allCompaniesOptions?.length) return [];
    return allCompaniesOptions.filter((item) => item.value <= 3);
  }, [allCompaniesOptions]);

  // ✅ กรองข้อมูลตาม filters
  const filteredData = useMemo(() => {
    let result = [...dataArr];

    // 1. กรองตาม Company (แก้ไขจาก includes เป็น ===)
    const allowedCompanies = COMPANY_GROUPS[companieSelect] ?? [companieSelect];
    result = result.filter((item) =>
      allowedCompanies.includes(item.COMPANY_ID),
    );

    // 2. กรองตาม Search Text
    const searchTrimmed = searchText.trim().toLowerCase();
    if (searchTrimmed) {
      result = result.filter((item) => {
        const contno = item.CONTNO?.toLowerCase() || "";
        const provincialCourt = item.provincialCourt || "";
        return (
          contno.includes(searchTrimmed) ||
          provincialCourt.includes(searchTrimmed)
        );
      });
    }

    // 3. กรองตาม Date Range
    if (dateRange?.length === 2) {
      const [startDate, endDate] = dateRange;
      const start = dayjs(startDate).startOf("day");
      const end = dayjs(endDate).endOf("day");

      result = result.filter((item) => {
        if (!item.dateOfPlaint) return false;
        const itemDate = dayjs(item.dateOfPlaint);
        return (
          (itemDate.isAfter(start) || itemDate.isSame(start, "day")) &&
          (itemDate.isBefore(end) || itemDate.isSame(end, "day"))
        );
      });
    }

    return result;
  }, [dataArr, companieSelect, searchText, dateRange]);

  // ✅ Update arrayTable เมื่อ filteredData เปลี่ยน
  useEffect(() => {
    setArrayTable(filteredData);
  }, [filteredData]);

  // ✅ Reset selection helper
  const resetSelection = useCallback(() => {
    setSelectedRowKeys([]);
    setSelectedRows([]);
    setDataModal([]);
  }, []);

  // ✅ Handlers
  const handleCompanyChange = useCallback(
    (value) => {
      setCompanieSelect(value);
      resetSelection();
    },
    [resetSelection],
  );

  const handleSearch = useCallback((e) => {
    setSearchText(e.target.value);
  }, []);

  const handleDateRangeChange = useCallback((dates) => {
    setDateRange(dates);
  }, []);

  const handleSelectChange = useCallback((keys, rows) => {
    setSelectedRowKeys(keys);
    setSelectedRows(rows);
    setDataModal(rows);
  }, []);

  const handleCreateAdvancePayment = useCallback(async () => {
    if (selectedRowKeys.length === 0) {
      message.warning("กรุณาเลือกสัญญาอย่างน้อย 1 รายการ");
      return;
    }
    if (selectedRowKeys.length > MAX_SELECTION) {
      message.warning(`สามารถเลือกได้สูงสุด ${MAX_SELECTION} รายการ`);
      return;
    }

    const dataCheck = [];

    // const dataCheck = await loadCheckBill();
    console.log(dataCheck);

    if (!dataCheck || dataCheck.length === 0) {
      setIsModalCreateAdvanePayment(true);
      return;
    }
    const unclearedItems = dataCheck.filter(
      (item) => item.advaneType === 1 && item.clearStatus !== 1,
    );

    if (unclearedItems.length === 0) {
      setIsModalCreateAdvanePayment(true);
    } else {
      notification.error({
        message: "ยังไม่เคลียร์รายการที่เบิก !",
        description: (
          <div>
            <ul style={{ marginTop: 8, paddingLeft: 20 }}>
              {unclearedItems.map((item, index) => (
                <li key={index}>{item.TMBILL}</li>
              ))}
            </ul>
          </div>
        ),
        duration: 5,
      });
    }
  }, [selectedRowKeys.length, loadCheckBill]);

  const handleResetFilters = useCallback(() => {
    setSearchText("");
    setDateRange(null);
    setCompanieSelect(defaultCompany);
    resetSelection();
    message.info("ล้างตัวกรองสำเร็จ");
  }, [defaultCompany, resetSelection]);

  const handleClearSelection = useCallback(() => {
    resetSelection();
    message.info("ยกเลิกการเลือกแล้ว");
  }, [resetSelection]);

  const handleModalCallback = useCallback(() => {
    resetSelection();
    loadMain();
  }, [loadMain]);

  // ✅ Row key generator
  const getRowKey = useCallback(
    (record) => `${record.loanId}_${record.lawsuitId}`,
    [],
  );

  // ✅ Check if filters are active
  const hasActiveFilters = useMemo(() => {
    return searchText || dateRange || companieSelect !== defaultCompany;
  }, [searchText, dateRange, companieSelect, defaultCompany]);

  const handleOpenCheckList = async () => {
    setIsModalOpen(true);
    const dataCheck = await loadCheckBill();
    const dataFilter = dataCheck.filter((item) => item.approvalStatus === 0);
    setCheckBillData(dataFilter);
    console.log("dataCheck", dataCheck);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  // ✅ Columns
  const columns = useMemo(
    () => [
      {
        title: "ลำดับ",
        key: "index",
        align: "center",
        width: 40,
        render: (_, __, index) => index + 1,
      },
      {
        title: "เลขที่สัญญา",
        dataIndex: "CONTNO",
        key: "CONTNO",
        align: "center",
        width: 60,
        render: (text) => (
          <Link style={{ fontWeight: 600 }}>{text || "-"}</Link>
        ),
      },
      {
        title: "ศาล",
        dataIndex: "provincialCourt",
        key: "provincialCourt",
        align: "center",
        width: 80,
        ellipsis: { showTitle: false },
      },
      {
        title: "วันยื่นฟ้อง",
        dataIndex: "dateOfPlaint",
        key: "dateOfPlaint",
        align: "center",
        width: 60,
        sorter: (a, b) => {
          const dateA = a.dateOfPlaint ? new Date(a.dateOfPlaint) : new Date(0);
          const dateB = b.dateOfPlaint ? new Date(b.dateOfPlaint) : new Date(0);
          return dateB - dateA;
        },
        render: (date) =>
          date ? dayjs(date).add(543, "year").format("D MMM YY") : "-",
      },
      {
        title: "หมายเหตุ",
        dataIndex: "mark",
        key: "mark",
        width: 150,
        ellipsis: { showTitle: false },
      },
    ],
    [],
  );

  // ✅ Row selection config
  const rowSelection = useMemo(
    () => ({
      selectedRowKeys,
      onChange: handleSelectChange,
      preserveSelectedRowKeys: true,
      getCheckboxProps: (record) => ({
        disabled:
          selectedRowKeys.length >= MAX_SELECTION &&
          !selectedRowKeys.includes(getRowKey(record)),
      }),
    }),
    [selectedRowKeys, handleSelectChange, getRowKey],
  );

  // ✅ Pagination config
  const pagination = useMemo(
    () => ({
      defaultPageSize: DEFAULT_PAGE_SIZE,
      showSizeChanger: true,
      showTotal: (total, range) =>
        `แสดง ${range[0]}-${range[1]} จาก ${total} รายการ`,
      pageSizeOptions: PAGE_SIZE_OPTIONS,
    }),
    [],
  );

  return (
    <>
      <Card>
        <Spin spinning={loading} size="large" tip="กำลังโหลดข้อมูล...">
          <Row gutter={[16, 16]}>
            {/* Header Row */}
            <Col span={24}>
              <Flex justify="space-between" align="center" wrap="wrap" gap={16}>
                <Space size="middle">
                  <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    size="large"
                    onClick={handleCreateAdvancePayment}
                    disabled={
                      selectedRowKeys.length === 0 ||
                      selectedRowKeys.length > MAX_SELECTION
                    }
                  >
                    สร้างรายการ
                    {selectedRowKeys.length > 0 &&
                      ` (${selectedRowKeys.length})`}
                  </Button>
                  {selectedRowKeys.length > 0 && (
                    <Button size="large" onClick={handleClearSelection}>
                      ยกเลิกการเลือก
                    </Button>
                  )}
                </Space>
                <Space size="middle">
                  <Button
                    color="green"
                    variant="outlined"
                    size="large"
                    onClick={handleOpenCheckList}
                  >
                    รายการรออนุมัติ
                  </Button>
                  <Select
                    placeholder="เลือกบริษัท"
                    showSearch
                    optionFilterProp="label"
                    options={companiesOptions}
                    onChange={handleCompanyChange}
                    value={companieSelect}
                    style={{ minWidth: 200 }}
                    size="large"
                    loading={loadingCompanies}
                    popupMatchSelectWidth={false}
                  />
                </Space>
              </Flex>
            </Col>

            {/* Filter Row */}
            <Col span={24}>
              <Flex justify="space-between" align="center" wrap="wrap" gap={16}>
                <Space size="middle">
                  <ThaiRangePicker
                    size="large"
                    value={dateRange}
                    onChange={handleDateRangeChange}
                    placeholder={["วันที่เริ่มต้น", "วันที่สิ้นสุด"]}
                    style={{ width: 300 }}
                  />
                  <Button
                    icon={<ReloadOutlined />}
                    size="large"
                    onClick={handleResetFilters}
                  >
                    ล้างตัวกรอง
                  </Button>
                </Space>

                <Input
                  placeholder="ค้นหาเลขสัญญา, ศาล"
                  onChange={handleSearch}
                  value={searchText}
                  style={{ width: 280 }}
                  allowClear
                  size="small"
                  suffix={<span style={{ marginRight: 5 }}>🔍</span>}
                />
              </Flex>
            </Col>

            {/* Summary Row */}
            {hasActiveFilters && (
              <Col span={24}>
                <Card size="small" style={{ background: "#f0f5ff" }}>
                  <Space split="|" size="large">
                    <span>
                      <strong>ผลการค้นหา:</strong> {arrayTable.length} รายการ
                    </span>
                    {searchText && (
                      <span>
                        <strong>ค้นหา:</strong> "{searchText}"
                      </span>
                    )}
                    {dateRange && (
                      <span>
                        <strong>ช่วงวันที่:</strong>{" "}
                        {dayjs(dateRange[0])
                          .add(543, "year")
                          .format("D MMM YY")}{" "}
                        -{" "}
                        {dayjs(dateRange[1])
                          .add(543, "year")
                          .format("D MMM YY")}
                      </span>
                    )}
                  </Space>
                </Card>
              </Col>
            )}

            {/* Table */}
            <Col span={24}>
              <Table
                size="small"
                columns={columns}
                dataSource={data}
                rowKey={getRowKey}
                scroll={{ x: 1400 }}
                loading={loading}
                pagination={pagination}
                rowSelection={rowSelection}
                footer={() => (
                  <Flex
                    justify="space-between"
                    align="center"
                    style={{ fontWeight: 500 }}
                  >
                    <span
                      style={{
                        color: selectedRowKeys.length > 0 ? "#1890ff" : "#999",
                      }}
                    >
                      {selectedRowKeys.length > 0
                        ? `✓ เลือกแล้ว ${selectedRowKeys.length} สัญญา`
                        : "ยังไม่ได้เลือกสัญญา"}
                    </span>
                    <span>จำนวนสัญญาทั้งหมด: {arrayTable.length} รายการ</span>
                  </Flex>
                )}
              />
            </Col>
          </Row>
        </Spin>
      </Card>
      <Modal
        title="รายการรออนุมัติเบิก"
        open={isModalOpen}
        onCancel={handleCancel}
        okButtonProps={{ style: { display: "none" } }}
        cancelText="ปิด"
        width={600}
      >
        <Spin spinning={loading}>
          {checkBillData.length > 0 ? (
            <List
              dataSource={checkBillData}
              renderItem={(item) => (
                <Card size="small" style={{ marginBottom: 12 }} hoverable>
                  <Flex justify="space-between" align="center">
                    <div>
                      <Flex align="center" gap={8}>
                        <FileTextOutlined style={{ color: "#1890ff" }} />
                        <Text strong copyable>
                          เลขที่อ้างอิงบิล: {item.TMBILL}
                        </Text>
                      </Flex>
                      <Text type="secondary" style={{ fontSize: 12 }}>
                        วันที่:{" "}
                        {dayjs(item.TMBILL_DT)
                          .add(543, "year")
                          .format("D MMM YYYY")}
                        {" | "}
                        {allCompaniesOptions.find(
                          (allCom) => allCom.value === item.COMPANY_ID,
                        )?.label || "-"}
                      </Text>
                    </div>
                    <Text strong style={{ color: "#1890ff", fontSize: 16 }}>
                      {Number(item.payamt).toLocaleString("th-TH")} บาท
                    </Text>
                  </Flex>
                </Card>
              )}
              footer={
                <Flex justify="flex-end" style={{ padding: "8px 0" }}>
                  <Text strong style={{ fontSize: 16 }}>
                    รวม:{" "}
                    <span style={{ color: "#1890ff" }}>
                      {checkBillData
                        .reduce((sum, item) => sum + Number(item.payamt), 0)
                        .toLocaleString("th-TH")}{" "}
                      บาท
                    </span>
                  </Text>
                </Flex>
              }
            />
          ) : (
            <Empty description="ไม่มีรายการรออนุมัติเบิก" />
          )}
        </Spin>
      </Modal>

      {isModalCreateAdvanePayment && (
        <CreateAdvanePayment
          open={isModalCreateAdvanePayment}
          close={setIsModalCreateAdvanePayment}
          dataDefault={data}
          //  dataDefault={dataModal}
          funcUpdateStatus={handleModalCallback}
          company={companieSelect}
        />
      )}
    </>
  );
};

const WithdrawAdvancePaymentInvestigate = MotionHoc(Main);
export default WithdrawAdvancePaymentInvestigate;
